export default __webpack_public_path__ + "static/media/lock-icon.f1b64b30.svg";